import React from 'react'

const Welcome = () => {
  return (
    <section>
        <div className='items-center justify-center flex blue-gradient_text font-semibold'>
            Welcome to my portfolio,<br/>
            For better experience, go to Graphics settings in your PC and <br/>change Graphics preference to your GPU (High Performance)
        </div>
        <div className='flex items-center justify-center'>
            <img src='settings.png' style={{height:400,width:400}}/>
            <img src='preference.png' style={{height:400,width:400}}/>
        </div>
    </section>
  )
}

export default Welcome